import { createSlice } from "@reduxjs/toolkit";

const guestDecodedSlice = createSlice({
  name: "guestDecoded",
  initialState: null, // No predefined structure
  reducers: {
    setGuestDecoded(state, action) {
      return action.payload; // Replace the state with the new payload
    },
    clearGuestDecoded() {
      return null; // Reset the state
    },
  },
});

export const { setGuestDecoded, clearGuestDecoded } = guestDecodedSlice.actions;

export default guestDecodedSlice.reducer;
